import axios from 'axios';
import router from '../router/index'
import { Message } from 'element-ui';
// 登录请求方法
const loginreq = (method, url, params) => {
  if(process.env.NODE_ENV==='production'){
    url ='http://tmapp.trackingmore.com' + url
    // url ='http://webapp.trackingmore.com' + url
  }
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        // withCredentials: true,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  if(process.env.NODE_ENV==='production'){
    url ='http://tmapp.trackingmore.com' + url
    // url ='http://webapp.trackingmore.com' + url
  }
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        // withCredentials: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(
      // res => res.data
      res=>
        res.data.code==40002?
        setTimeout(() => {
          Message("您还未登录，请重新登录")
          setTimeout(() => {
            router.push( '/' )
          }, 1000)
        }
        ,1000)
        :
        res.data
      );
};

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js